import {
	BreakpointWrapper,
	Breakpoints,
	CTA,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TextTag,
	TokenTextAppearance,
	TokenTextColor,
	styled,
} from '@volkswagen-onehub/components-core';
import { MotionValue } from 'framer-motion';
import React, { useContext } from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { Environment } from '../../../enviroment';
import { formatOwnership } from '../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { VipsGaleria } from './vips-galeria';

const VipsContentWrapper = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
`;

export const VipsContent = ({ progress }: { progress: MotionValue<number> }): React.ReactElement => {
	const trackingManager = useTrackingManager();
	const { portalService, navigationService } = useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const environmentPath = Environment.getInstance().vips;
	const target = navigationService.navigateTo(environmentPath, {});

	const handleTrackingOnClick = () => {
		trackingManager.trackClubVWButtonClick(
			'Te esperamos en Instagram',
			{ contentId: 'VIPS - Open Instagram' },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		if (target) {
			target.push();
		} else {
			console.log('Page with id non exsistent');
		}
	};

	return (
		<Container data-testid="vips-content__container">
			<Layout
				data-testid="vips-content__layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 1 },
						{ name: 'vips-left-content', columns: 22 },
						{ name: '.', columns: 1 },
						{ name: '.', columns: 0 },
						{ name: 'vips-gallery', columns: 24 },
						{ name: '.', columns: 0 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 1 },
						{ name: 'vips-left-content', columns: 9 },
						{ name: '.', columns: 1 },
						{ name: 'vips-gallery', columns: 12 },
						{ name: '.', columns: 1 },
					],
				}}
				allowOverflowingContent
			>
				<VipsContentWrapper>
					<Container
						wrap={'always'}
						gutter={ContainerGutter.static400}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0300,
							},
							bottom: {
								[Breakpoints.default]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0300,
							},
						}}
						data-testid="vips-left-content"
					>
						<Container wrap={'always'} gutter={ContainerGutter.static200}>
							<Text
								tag={TextTag.h2}
								appearance={TokenTextAppearance.headline500}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
							>
								<Text bold>La cueva de Rodrigo:</Text> de soñar con un GTI a crearle un santuario
							</Text>

							<Container>
								<Text
									tag={TextTag.span}
									appearance={TokenTextAppearance.bigcopy100}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Hay quienes conducen un Volkswagen y hay quienes hacen historia. Rodrigo lleva años cuidando,
									restaurando y creando recuerdos que demuestran que su pasión por el GTI va mucho más allá de la
									carretera.
								</Text>
							</Container>
							<Container>
								<Text
									tag={TextTag.span}
									appearance={TokenTextAppearance.bigcopy100}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Descubre su cueva llena de recuerdos.
								</Text>
							</Container>
						</Container>
						<CTA tag="a" emphasis="primary" onClick={handleTrackingOnClick} target="_blank">
							<Text>Conoce toda su historia</Text>
						</CTA>
					</Container>
				</VipsContentWrapper>
				<Container data-testid="vips-gallery">
					<BreakpointWrapper max={Breakpoints.b560}>
						<VipsGaleria progress={progress} rows={2} horizontal />
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b560} max={Breakpoints.b960}>
						<VipsGaleria progress={progress} rows={1} horizontal />
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b960}>
						<VipsGaleria progress={progress} rows={3} />
					</BreakpointWrapper>
				</Container>
			</Layout>
		</Container>
	);
};
